import { render, staticRenderFns } from "./almacen.vue?vue&type=template&id=1f953498&"
import script from "./almacen.vue?vue&type=script&lang=js&"
export * from "./almacen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports